import Swiper from "swiper"
import { Navigation, EffectCoverflow, Pagination } from "swiper/modules"
import "swiper/css"
import "swiper/css/navigation"
import "swiper/css/effect-coverflow"

document.addEventListener("DOMContentLoaded", function () {
  const newsSlider = new Swiper("#newsSlider", {
    modules: [Navigation],
    navigation: {
      nextEl: ".news-button-next",
      prevEl: ".news-button-prev",
    },
    preventClicks: false,
    slidesPerView: 1,
    spaceBetween: 15,
    breakpoints: {
      // sm
      640: {
        slidesPerView: 1,
        spaceBetween: 40,
      },
      // lg
      1024: {
        slidesPerView: 2,
        spaceBetween: 22,
      },
    },
  })
  const rewardsSlider = new Swiper("#rewardSlider", {
    modules: [Navigation, Pagination],
    navigation: {
      nextEl: ".reward-button-next",
      prevEl: ".reward-button-prev",
    },
    pagination: {
      el: ".reward-pagination",
      bulletActiveClass: "reward-bullet-active",
      bulletClass: "reward-bullet",
      clickable: true,
      renderBullet: function (index, className) {
        return '<div class="' + className + '"></div>'
      },
    },
    preventClicks: false,
    slidesPerView: 1,
    spaceBetween: 40,
    breakpoints: {
      // sm
      640: {
        slidesPerView: 1,
        spaceBetween: 40,
      },
      // lg
      1024: {
        slidesPerView: 1,
        spaceBetween: 200,
      },
    },
  })
  const teamSwiper = new Swiper("#teamSwiper", {
    modules: [Navigation],
    navigation: {
      nextEl: ".team-button-next",
      prevEl: ".team-button-prev",
    },
    preventClicks: false,
    slidesPerView: 1.05,
    spaceBetween: 22,
    breakpoints: {
      // sm
      640: {
        slidesPerView: 2,
        spaceBetween: 40,
      },
      // lg
      1024: {
        slidesPerView: 3,
        spaceBetween: 40,
      },
    },
  })

  const partnerSwiper = new Swiper("#partnerSwiper", {
    modules: [Navigation],
    navigation: {
      nextEl: ".partner-button-next",
      prevEl: ".partner-button-prev",
    },
    slidesPerView: 1.05,
    spaceBetween: 24,
    breakpoints: {
      // sm
      640: {
        slidesPerView: 2,
        spaceBetween: 60,
      },
      // xl
      1280: {
        slidesPerView: 3,
        spaceBetween: 80,
      },
      // xl
      1580: {
        slidesPerView: 4,
        spaceBetween: 80,
      },
    },
  })

  const leftAppSwiper = new Swiper("#leftAppSwiper", {
    modules: [Navigation, EffectCoverflow],
    navigation: {
      nextEl: ".leftApp-button-next",
      prevEl: ".leftApp-button-prev",
    },
    effect: "coverflow",
    grabCursor: true,
    centeredSlides: true,
    slidesPerView: "auto",
    initialSlide: 0,
    coverflowEffect: {
      rotate: 0,
      stretch: 0,
      depth: 200,
      modifier: 1,
      slideShadows: true,
    },
  })

  const rightAppSwiper = new Swiper("#rightAppSwiper", {
    modules: [Navigation, EffectCoverflow],
    navigation: {
      nextEl: ".rightApp-button-next",
      prevEl: ".rightApp-button-prev",
    },
    effect: "coverflow",
    grabCursor: true,
    centeredSlides: true,
    slidesPerView: "auto",
    initialSlide: 1,
    coverflowEffect: {
      rotate: 0,
      stretch: 0,
      depth: 200,
      modifier: 1,
      slideShadows: true,
    },
  })

  const investorSwiper = new Swiper("#investorSwiper", {
    modules: [Navigation, EffectCoverflow],
    navigation: {
      nextEl: ".investor-button-next",
      prevEl: ".investor-button-prev",
    },
    preventClicks: false,
    slidesPerView: 1,
    spaceBetween: 5,
    breakpoints: {
      // sm
      640: {
        slidesPerView: 3,
        spaceBetween: 0,
        effect: "coverflow",
        centeredSlides: true,
      },
      // xl
      1280: {
        slidesPerView: 5,
        spaceBetween: 0,
        effect: "coverflow",
        centeredSlides: true,
      },
    },
    initialSlide: 0,
    coverflowEffect: {
      rotate: 0,
      stretch: 0,
      depth: 150,
      modifier: 1,
      slideShadows: false,
    },
  })
  const phaseSwiper = new Swiper("#phaseSwiper", {
    modules: [Navigation, EffectCoverflow],
    navigation: {
      nextEl: ".phase-button-next",
      prevEl: ".phase-button-prev",
    },
    preventClicks: false,
    slidesPerView: 1.05,
    spaceBetween: 25,
    breakpoints: {
      // sm
      640: {
        slidesPerView: 1,
        spaceBetween: 45,
        effect: "coverflow",
      },
    },
    initialSlide: 0,
    coverflowEffect: {
      rotate: 0,
      stretch: 0,
      depth: 150,
      modifier: 1,
      slideShadows: false,
    },
  })

  // console.log({teamSwiper, partnerSwiper, investorSwiper, leftAppSwiper, rightAppSwiper})
})
